<template>
  <div class="iv-header">
    <div class="iv-header-bottom">
      <Nav></Nav>
    </div>
  </div>
</template>

<script>
import { Poptip, Tabs, Badge } from 'iview'
import IconFont from '@/components/iconfont'
import Nav from './nav'
import imagePath from '@/mixins/image-path'
export default {
  mixins: [imagePath],
  data () {
    return {
      messageCount: 9,
      userName: '',
      headImg: '',
      pageTitle: document.title,
      showScreen: true,
      screenTxt: '全屏展示',
      messageLabel: (h) => {
        return h('div', [
          h('span', '消息'),
          h('Badge', {
            props: {
              count: this.messageCount
            }
          })
        ])
      }
    }
  },
  created () {
    //this.getCurrentUser()
  },
  methods: {
    //获取当前用户信息
    getCurrentUser () {
      this.$ajax({
        url: 'api-ouser/portal/user/getCurrentUser',
        type: 'GET'
      }).then(({data}) => {
        console.log(data)
        this.userName = data.data.name
        this.getImgSrc('headImg', 'headImg', data.data.headImg)
      })
    },
    //设为首页
    setHome () {
      let url = window.location.href
      if (document.all) {
        document.body.style.behavior = 'url(#default#homepage)'
        document.body.setHomePage(url)
      } else if (window.sidebar) {
        if (window.netscape) {
          try {
            window.netscape.security.PrivilegeManager.enablePrivilege('UniversalXPConnect')
          } catch (e) {
            this.$Message.warning({
              content: '该操作被浏览器拒绝，假如想启用该功能，请在地址栏内输入 about:config,然后将项 signed.applets.codebase_principal_support 值该为true',
              closable: true,
              duration: 2
            })
          }
        }
        /*setInterval(() => {
          var prefs = Components.classes['@http://mozilla.org/preferences-service;1'].getService(Components.interfaces.nsIPrefBranch)
          prefs.setCharPref('browser.startup.homepage', 'http://www.w3cmark.com')
        }, 500)*/
      } else {
        this.$Message.warning({
          content: '您的浏览器不支持自动自动设置首页, 请使用浏览器菜单手动设置!',
          closable: true,
          duration: 2
        })
      }
    },
    //加入收藏夹
    addCollection () {
      let url = window.location
      let title = document.title
      let ua = navigator.userAgent.toLowerCase()

      if (ua.indexOf('360se') > -1) {
        this.$Message.warning({
          content: '由于360浏览器功能限制，请按 Ctrl+D 手动收藏！',
          closable: true,
          duration: 2
        })
      } else if (ua.indexOf('msie 8') > -1) {
        window.external.AddToFavoritesBar(url, title) //IE8
      } else if (document.all) {
        try {
          window.external.addFavorite(url, title)
        } catch (e) {
          this.$Message.warning({
            content: '您的浏览器不支持,请按 Ctrl+D 手动收藏!',
            closable: true,
            duration: 2
          })
        }
      } else if (window.sidebar) {
        window.sidebar.addPanel(title, url, '')
      } else {
        this.$Message.warning({
          content: '您的浏览器不支持,请按 Ctrl+D 手动收藏!',
          closable: true,
          duration: 2
        })
      }
    },
    //帮助中心
    helpCenter () {

    },
    //消息
    lookMessage () {
      //this.messageCount = 0
    },
    /*
    * @description 设置全屏
    * @params fullscreenElement属性返回正处于全屏状态的Element节点，如果当前没有节点处于全屏状态，则返回null
    */
    fullScreen () {
      //判断可不可以全屏
      let fullscreenEnabled = document.fullscreenEnabled ||
          document.mozFullScreenEnabled ||
          document.webkitFullscreenEnabled ||
          document.msFullscreenEnabled
      let fullscreenElement = document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement
      if (fullscreenEnabled) {
        if (fullscreenElement) {
          this.exitFullscreen()
        } else {
          this.setFullscreen()
        }
      } else {
        this.showScreen = false
      }
    },
    //进入全屏
    setFullscreen (element) {
      let el = element instanceof HTMLElement ? element : document.documentElement
      let rfs = el.requestFullscreen ||
          el.webkitRequestFullscreen ||
          el.mozRequestFullScreen ||
          el.msRequestFullscreen
      if (rfs) {
        rfs.call(el)
      } else if (window.ActiveXObject) {
        var ws = new window.ActiveXObject('WScript.Shell')
        ws && ws.SendKeys('{F11}')
      }
    },
    //退出全屏
    exitFullscreen () {
      let efs = document.exitFullscreen ||
          document.webkitExitFullscreen ||
          document.mozCancelFullScreen ||
          document.msExitFullscreen
      if (efs) {
        efs.call(document)
      } else if (window.ActiveXObject) {
        let ws = new window.ActiveXObject('WScript.Shell')
        ws && ws.SendKeys('{F11}')
      }
    },
    //退出
    signOut () {
      this.$ajax({
        url: 'logout',
        type: 'GET'
      }).then((res) => {
        this.$Message.success('登出成功')
        this.$router.push('/')
      })
    }
  },
  beforeDestroy () {
    this.$Message.destroy()
  },
  components: {
    Poptip,
    Tabs,
    Badge,
    IconFont,
    Nav
  }
}
</script>

<style lang="scss">
.iv-header {
  .ivu-badge-dot {
    top: 0;
    right: -12px;
  }
  .iv-title-hide {
    min-width: auto;
    .ivu-poptip-title {
      display: none;
    }
  }
}
</style>
<style lang="scss" scoped>
.iv-header {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 999;
  .iv-header-top {
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    background: #fff;
    border-bottom: 1px solid rgba(0,0,0,0.09);
    ul {
      li {
        cursor: pointer;
        height: 40px;
        a {
          color: rgba(0,0,0,0.45);
        }
      }
      li:hover {
        color: #2d8cf0;
      }
    }
    .iv-header-left {
      ul {
        li {
          border-right: 1px solid rgba(0,0,0,0.09);
        }
      }
    }
    .iv-header-right {
      ul {
        li {
          border-left: 1px solid rgba(0,0,0,0.09);
          width: 64px;
          text-align: center;
          img {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            vertical-align: middle;
          }
        }
        li:first-child {
          width: 116px;
        }
      }
    }
  }
  .iv-header-bottom {
    clear: both;
    width: 100%;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.09);
  }
}
</style>


// WEBPACK FOOTER //
// src/page/header/index.vue